import React, { useMemo } from 'react';
import { useDeviceType } from '../hooks/useDeviceType';

const Spheres = () => {
  const { isMobile } = useDeviceType();

  // Define static light strips with adjusted positions to fill left and right
  const lightStrips = useMemo(() => [
    {
      width: isMobile ? '40%' : '50%',
      height: isMobile ? '8%' : '12%',
      top: isMobile ? '5%' : '10%',
      left: isMobile ? '5%' : '2%', // Shifted leftward to fill the left side
      rotate: isMobile ? '10deg' : '15deg',
      gradient: 'linear-gradient(45deg, rgba(73, 17, 28, 0.3) 0%, rgba(73, 17, 28, 0.1) 50%, transparent 100%)',
    },
    {
      width: isMobile ? '50%' : '60%',
      height: isMobile ? '10%' : '15%',
      top: isMobile ? '85%' : '80%',
      left: isMobile ? '40%' : '35%', // Shifted rightward to fill the right side
      rotate: isMobile ? '-15deg' : '-20deg',
      gradient: 'linear-gradient(135deg, rgba(73, 17, 28, 0.25) 0%, rgba(73, 17, 28, 0.05) 50%, transparent 100%)',
    },
  ], [isMobile]);

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      {lightStrips.map((strip, index) => (
        <div
          key={index}
          className="absolute"
          style={{
            width: strip.width,
            height: strip.height,
            top: strip.top,
            left: strip.left,
            transform: `rotate(${strip.rotate})`,
            background: strip.gradient,
            filter: 'blur(20px)',
            borderRadius: '10px',
            transformOrigin: 'center',
            position: 'fixed',
          }}
        />
      ))}
    </div>
  );
};

export default Spheres;